<template>
  <div class="adp-competences">
    <div class="competence-header">
      <button class="btn adp-btn mr-4" :class="{'disabled': ! areActionsEnabled}" @click="addNewGroup">{{ $t('admin.add_group') }}</button>
      <div class="d-flex align-items-center ml-4" :class="{'catalog-switched': isInactiveItemsHidden}">
        <p class="mb-0 mr-3 catalog-switch-text">{{ $t('catalog.hide_inactive') }}</p>
        <b-form-checkbox style="margin-bottom: 7px" switch size="lg" @change="hideInactiveItems()"/>
      </div>
      <button class="btn adp-btn ml-4" @click="competenceExport">{{ $t('admin.report_button') }}</button>
      <button class="btn adp-btn ml-4" :class="{'disabled': ! areActionsEnabled}" @click="competenceImport">{{ $t('admin.import') }}</button>
    </div>

    <div class="tree-block" v-if="loading">
      {{ $t('voc.loading') }}
    </div>
    <div class="tree-block" v-if="!loading">
      <competencies-tree
                      v-if="competenciesTree.length"
                      v-for="item, index in competenciesTree"
                      v-show="!(!!item.is_hidden && isInactiveItemsHidden)"
                      :key="item.id"
                      :node="item"
                      :path="[index]"
                      :isHideToggleActive="isInactiveItemsHidden"
                      :isParentHidden="!!item.is_hidden && isInactiveItemsHidden"
                      v-on:open-cm="openCM">
      </competencies-tree>

      <div class="adp-task--crud-actions" :style="cmStyles" v-if="isContextMenuVisible" v-click-outside="() => hideCM()">
        <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="hideAndShow(1);"
            v-if="!activeNode.is_hidden">
          {{ $t('admin.hide') }}
        </div>
        <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="hideAndShow(0);"
            v-if="activeNode.is_hidden">
          {{ $t('admin.show') }}
        </div>
        <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="openAddNewItemModal()"
            v-if="activeNode.type !== 'skill'">
          {{ addItemText }}
        </div>
        <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="openRenameItemModal()">
          {{ $t('admin.rename') }}
        </div>
        <div class="btn adp-btn adp-btn__t-left adp-btn__light" @click="deleteItem();"
            v-if="activeNode.can_be_deleted">
          {{ $t('admin.delete') }}
        </div>
      </div>

      <!-- Modals -->
      <rename-tree-item-modal :tree-item="activeNode" @data-changed="renameItem" />
      <add-new-tree-item-modal :parent-type="activeNode.type || ''" @data-created="createNewItem" />
      <reports-modal v-show="isReportsOpened" :is-reports-opened="isReportsOpened" @close-reports-modal="isReportsOpened = false"/>
    </div>
  </div>
</template>

<script>
import api from '../api';
import CompetenciesTree from "./CompetenciesTree";
import RenameTreeItemModal from "./admin/RenameTreeItemModal";
import AddNewTreeItemModal from "./admin/AddNewTreeItemModal";
import ReportsModal from "./modals/ReportsModal";

export default {
  name: "Competences",
  components: {
    'add-new-tree-item-modal': AddNewTreeItemModal,
    'rename-tree-item-modal': RenameTreeItemModal,
    'reports-modal': ReportsModal,
    'competencies-tree': CompetenciesTree,
  },
  data: function () {
    return {
      reportsButton: document.getElementById('reports-download'),
      reportsLoadingButton: document.getElementById('reports-download-circle'),
      isReportsOpened: false,

      competenciesTree: {},
      localSavedTree: [],
      activeNode: {},
      activePath: [],
      loading: false,
      isContextMenuVisible: false,
      isInactiveItemsHidden: false,
      areActionsEnabled: false,
      cmTop: 0,
      cmLeft: 0,
    }
  },
  computed: {
    cmStyles() {
      return {
        top: `${this.cmTop}px`,
        left: `${this.cmLeft}px`,
        right: 'unset',
      };
    },
    addItemText() {
      if (this.activeNode.type === 'group') return this.$t('admin.add_function');
      if (this.activeNode.type === 'function') return this.$t('admin.add_competence');
      if (this.activeNode.type === 'competence') return this.$t('admin.add_skill');
    }
  },
  methods: {
    async hideInactiveItems() {
      this.isInactiveItemsHidden = !this.isInactiveItemsHidden;
    },
    async getTree() {
      this.loading = true;
      this.isContextMenuVisible = false;
      this.areActionsEnabled = false;

      const resp = await api.getCompetencies();
      this.competenciesTree = Object.values(resp.data.groups);

      this.loading = false;
      this.areActionsEnabled = true;
    },
    async openCM(event, node, path) {
      if (this.areActionsEnabled) {
        let childrenPath = _.flatMap(path, (e, key) => key ? ['children', e] : [e]);
        let sourceObject = _.get(this.competenciesTree, childrenPath);

        if (node.type !== sourceObject.type || node.id !== sourceObject.id) {
          throw new Error('Array data out of sync (different type or id)');
        }

        if (node !== sourceObject) {
          throw new Error('Array data out of sync (different variable links)');
        }

        this.cmLeft = event.pageX;
        this.cmTop = event.pageY;

        this.isContextMenuVisible = true;
        this.activeNode = sourceObject;
        this.activePath = childrenPath;
      }
    },
    hideCM() {
      this.isContextMenuVisible = false;
    },
    async hideAndShow(isHidden) {
      this.isContextMenuVisible = false;
      this.areActionsEnabled = false;

      const type = this.activeNode.type;
      const id = this.activeNode.id;
      
      let apiMethod = null;
      if (type === 'group' && isHidden === 1) apiMethod = api.hideGroup;
      if (type === 'group' && isHidden === 0) apiMethod = api.showGroup;
      if (type === 'function' && isHidden === 1) apiMethod = api.hideFunction;
      if (type === 'function' && isHidden === 0) apiMethod = api.showFunction;
      if (type === 'competence' && isHidden === 1) apiMethod = api.hideCompetence;
      if (type === 'competence' && isHidden === 0) apiMethod = api.showCompetence;
      if (type === 'skill' && isHidden === 1) apiMethod = api.hideSkill;
      if (type === 'skill' && isHidden === 0) apiMethod = api.showSkill;

      if (apiMethod) {
        await apiMethod(id).then(() => {
          this.recursiveUpdateIsHidden(this.activeNode, isHidden);
        }).catch(() => console.error('API request has been failed'));
      }

      this.areActionsEnabled = true;
    },
    recursiveUpdateIsHidden(node, status) {
      node.is_hidden = status;

      if (node.children && node.children.length) {
        node.children.forEach(e => this.recursiveUpdateIsHidden(e, status));
      }
    },
    async deleteItem() {
      this.isContextMenuVisible = false;
      this.areActionsEnabled = false;

      const type = this.activeNode.type;
      const id = this.activeNode.id;

      let apiMethod = null;
      if (type === 'group') apiMethod = api.deleteGroup;
      if (type === 'function') apiMethod = api.deleteFunction;
      if (type === 'competence') apiMethod = api.deleteCompetence;
      if (type === 'skill') apiMethod = api.deleteSkill;

      if (apiMethod) {
        await apiMethod(id).then(() => {
          let parentPath = this.activePath.slice(0, -1);

          let parentObject = this.competenciesTree;
          if (parentPath.length !== 0) {
            parentObject = _.get(this.competenciesTree, parentPath);
          }

          let key = this.activePath.at(-1);
          parentObject.splice(key, 1);
        }).catch(() => console.error('API request has been failed'));
      }
      
      this.areActionsEnabled = true;
    },
    openRenameItemModal() {
      this.$bvModal.show('rename-tree-item-modal');
    },
    async renameItem(updatedData, oldNode) {
      this.$bvModal.hide('rename-tree-item-modal');

      this.isContextMenuVisible = false;
      this.areActionsEnabled = false;

      if (oldNode !== this.activeNode) {
        throw new Error('Array data out of sync (different variable link) during renaming');
      }

      const type = this.activeNode.type;
      const id = this.activeNode.id;

      let apiMethod = null;
      if (type === 'group') apiMethod = api.updateGroup;
      if (type === 'function') apiMethod = api.updateFunction;
      if (type === 'competence') apiMethod = api.updateCompetence;
      if (type === 'skill') apiMethod = api.updateSkill;

      if (apiMethod) {
        await apiMethod(id, updatedData).then(() => {
          this.activeNode.title = updatedData.name_ru;
          this.activeNode.name_en = updatedData.name_en;
          this.activeNode.name_fr = updatedData.name_fr;
        }).catch(() => console.error('API request has been failed'));
      }

      this.areActionsEnabled = true;
    },
    addNewGroup() {
      if (this.areActionsEnabled) {
        this.activeNode = {};
        this.openAddNewItemModal();
      }
    },
    openAddNewItemModal() {
      this.$bvModal.show('add-new-tree-item-modal');
    },
    async createNewItem(newNodeData, parentType) {
      this.$bvModal.hide('add-new-tree-item-modal');

      this.isContextMenuVisible = false;
      this.areActionsEnabled = false;

      if (parentType !== this.activeNode.type && typeof this.activeNode.type !== 'undefined') {
        throw new Error('Array data out of sync (different variable type) during creation');
      }

      let responseData = null;
      let apiMethod = null;
      let childType = "";

      if (! Object.values(this.activeNode).length) {
        apiMethod = api.createGroup;
        childType = 'group';
      } else {
        const type = this.activeNode.type;
        const id = this.activeNode.id;

        if (type === 'group') {
          newNodeData.group_id = id;
          apiMethod = api.createFunction;
          childType = 'function';
        }
        if (type === 'function') {
          newNodeData.function_id = id;
          apiMethod = api.createCompetence;
          childType = 'competence';
        }
        if (type === 'competence') {
          newNodeData.competence_id = id;
          apiMethod = api.createSkill;
          childType = 'skill';
        }
      }

      if (apiMethod) {
        await apiMethod(newNodeData).then((resp) => {
          responseData = resp;
          responseData.type = childType;
        }).then(() => {
          let newNode = {
            title: responseData.name_ru,
            can_be_deleted: true,
            is_hidden: 0,
            type: responseData.type,
            id: responseData.id,
            name_en: responseData.name_en,
            name_fr: responseData.name_fr
          };

          if (newNode.type !== 'skill') {
            newNode.children = [];
          }

          if (newNode.type === 'group') {
            this.competenciesTree.push(newNode);
          } else {
            this.activeNode.children.push(newNode);
          }
        }).catch(() => console.error('API request has been failed'));
      }

      this.areActionsEnabled = true;
    },
    async competenceExport() {
      await api.competenceExport().then(response => {
        const url = response.data.download_url;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'competence-report.xlsx');
        link.click();
      });
    },
    competenceImport() {
      if (this.areActionsEnabled) {
        const input = document.createElement('input');
        input.type = 'file';
        input.onchange = e => this.getExcelFile(e);
        input.click();
      }
    },
    async getExcelFile(e) {
      const file = e.target.files[0];
      const data = new FormData();
      data.append('file', file)

      await api.competenceImport(data)
        .catch( error => {
          console.error(error);
        });

      await this.getTree();
    },
  },
  async mounted() {
    this.reportsButton.onclick = () => this.isReportsOpened = !this.isReportsOpened;
    this.reportsLoadingButton.onclick = () => this.isReportsOpened = !this.isReportsOpened;

    await this.getTree();
  },
}
</script>

<style scoped>
.adp-competences {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  padding: 20px;
}

.competence-header {
  display: flex;
  border-bottom: 1px solid #CCCCCC;
  margin: 0 -20px;
  padding: 0 17px 13px;
}

.tree-block {
  margin: 40px 30px;
}
</style>
